function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconGroup = function SvgIconGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.86842C1.5 3.28053 1.5 2.48659 1.99329 1.99329C2.48659 1.5 3.28053 1.5 4.86842 1.5C6.45631 1.5 7.25025 1.5 7.74354 1.99329C8.23684 2.48659 8.23684 3.28053 8.23684 4.86842C8.23684 6.45631 8.23684 7.25025 7.74354 7.74354C7.25025 8.23684 6.45631 8.23684 4.86842 8.23684C3.28053 8.23684 2.48659 8.23684 1.99329 7.74354C1.5 7.25025 1.5 6.45631 1.5 4.86842Z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7637 14.1301C10.7637 12.5422 10.7637 11.7483 11.257 11.255C11.7503 10.7617 12.5442 10.7617 14.1321 10.7617C15.72 10.7617 16.5139 10.7617 17.0072 11.255C17.5005 11.7483 17.5005 12.5422 17.5005 14.1301C17.5005 15.718 17.5005 16.512 17.0072 17.0053C16.5139 17.4986 15.72 17.4986 14.1321 17.4986C12.5442 17.4986 11.7503 17.4986 11.257 17.0053C10.7637 16.512 10.7637 15.718 10.7637 14.1301Z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 14.1301C1.5 12.5422 1.5 11.7483 1.99329 11.255C2.48659 10.7617 3.28053 10.7617 4.86842 10.7617C6.45631 10.7617 7.25025 10.7617 7.74354 11.255C8.23684 11.7483 8.23684 12.5422 8.23684 14.1301C8.23684 15.718 8.23684 16.512 7.74354 17.0053C7.25025 17.4986 6.45631 17.4986 4.86842 17.4986C3.28053 17.4986 2.48659 17.4986 1.99329 17.0053C1.5 16.512 1.5 15.718 1.5 14.1301Z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7637 4.86842C10.7637 3.28053 10.7637 2.48659 11.257 1.99329C11.7503 1.5 12.5442 1.5 14.1321 1.5C15.72 1.5 16.5139 1.5 17.0072 1.99329C17.5005 2.48659 17.5005 3.28053 17.5005 4.86842C17.5005 6.45631 17.5005 7.25025 17.0072 7.74354C16.5139 8.23684 15.72 8.23684 14.1321 8.23684C12.5442 8.23684 11.7503 8.23684 11.257 7.74354C10.7637 7.25025 10.7637 6.45631 10.7637 4.86842Z",
    strokeWidth: 1.5
  }));
};
export default SvgIconGroup;